import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, List, ListItem, ListItemButton, ListItemIcon, ListItemText, MenuItem, Select, SelectChangeEvent, TextField, Typography } from '@mui/material';
import { Vertical } from './Vertical';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ErrorDialog from '../utilities/ErrorDialog';

export interface IVerticalNewProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
}

export interface IVerticalNewState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
    errors: any[];
    openErroDialog: boolean;
    verticales: any[];
}

export default class VerticalNew extends React.Component<IVerticalNewProps, IVerticalNewState> {
    _vertical: Vertical = new Vertical();
    
    public constructor(props: IVerticalNewProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            openErroDialog: false,
            errorMessage: '',
            errors: [],
            verticales: []
        }
    }

    componentDidMount(): void {
        this.GetVerticales();
    }

    componentWillReceiveProps(nextProps: Readonly<IVerticalNewProps>, nextContext: any): void {
        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <React.Fragment>
                <Dialog open={this.state.open && this.state.errors.length == 0} fullWidth>
                    <DialogTitle>
                        Nuevo vertical
                    </DialogTitle>
                    <DialogContent>
                        {
                            this.state.hasErrors && (
                                <Alert severity="error" style={{marginBottom: '10px'}}>
                                    {
                                        this.state.errorMessage
                                    }
                                </Alert>
                            )
                        }
                        <Box>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField required variant='standard' label='Nombre' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._vertical.name = event.target.value;
                                    }
                                }}></TextField>
                            </FormControl>
                            <FormControl fullWidth variant="standard" style={{marginBottom: '20px'}}>
                                <InputLabel id="labelVerticales">Vertical del que depende</InputLabel>
                                <Select label="Vertical del que depende" labelId='labelVerticales' onChange={(event: SelectChangeEvent) => {
                                    this.setState(
                                        {
                                            hasErrors: false,
                                            errorMessage: ''
                                        }
                                    );
                                    this._vertical.parentId = Number(event.target.value);
                                }}>
                                    {
                                        this.state.verticales.map((value: Vertical, index: number) => {
                                            return (
                                                <MenuItem value={value.id}>
                                                    {
                                                        value.name
                                                    }
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl fullWidth style={{marginBottom: '20px'}}>
                                <TextField type='number' required variant='standard' label='Barbecho por defecto (en días)' onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                    if(event.target.value == '') {
                                        this.setState(
                                            {
                                                hasErrors: true,
                                                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios.'
                                            }
                                        );
                                    }
                                    else {
                                        this.setState(
                                            {
                                                hasErrors: false,
                                                errorMessage: ''
                                            }
                                        );
                                        this._vertical.defaultFallow = Number(event.target.value);
                                    }
                                }}></TextField>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.Save.bind(this)}>OK</Button>
                        <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.errors.length > 0} fullWidth>
                    <DialogTitle>
                        Error
                    </DialogTitle>
                    <DialogContent>
                        <Typography variant='body2'>
                            Se ha producido el siguiente error al guardar los datos:
                        </Typography>
                        <div className='errors'>
                            <List>
                                {
                                    this.state.errors.map((value: string, index: number) => {
                                        return (
                                            <ListItem disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <CancelOutlinedIcon />
                                                    </ListItemIcon>
                                                    <ListItemText primary={value} />
                                                </ListItemButton>
                                            </ListItem>
                                        )
                                    })
                                }
                            </List>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            this.setState(
                                {
                                    errors: []
                                }
                            );
                        }}>Ok</Button>
                    </DialogActions>
                </Dialog>
                <ErrorDialog open={this.state.openErroDialog} onClose={this.Close.bind(this)} />
            </React.Fragment>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                openErroDialog: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private GetVerticales() {
        let url = `${Common.END_POINT}/masters/Verticales`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    verticales: response
                }
            );
        })
    }

    private Save() {
        if(this._vertical.name == '' || this._vertical.name == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        if(this._vertical.defaultFallow == -1 || this._vertical.defaultFallow == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/verticales`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._vertical),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            if(this.props.onSave != null) {
                this.GetVerticales();
                this.props.onSave();
            }

            this._vertical = new Vertical();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false,
                    openErroDialog: true
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._vertical = new Vertical();
        });
    }
}